"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Search;
exports.useDebouncedCallback = useDebouncedCallback;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _TextInput = require("../TextInput");
var _Icon = _interopRequireDefault(require("../Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useDebouncedCallback(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      return callback.apply(void 0, args);
    }, delay);
  };
}
var debouncedSearch = function debouncedSearch() {};
function Search(props) {
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    searchedValue = _useState2[0],
    setSearchedValue = _useState2[1];
  var onSearch = props.onSearch,
    locale = props.locale,
    placeholder = props.placeholder;
  (0, _react.useEffect)(function () {
    debouncedSearch = useDebouncedCallback(onSearch);
  }, []);
  function handleChange(e) {
    var value = e.target.value;
    debouncedSearch(value);
    setSearchedValue(value);
  }
  return /*#__PURE__*/_react.default.createElement(_TextInput.TextInput, {
    onChange: handleChange,
    suffix: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "search"
    }),
    placeholder: placeholder || locale.SearchPlaceholder,
    value: searchedValue,
    size: "small",
    style: {
      width: 200
    }
  });
}